import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import FormikContainer from "../../components/Formik/FormikContainer";
import { Form } from "formik";
import * as Yup from "yup";
import FieldContainer from "../../components/Formik/FieldContainer";
import DButton from "../../components/DButton";
import { Spinner } from "@chakra-ui/react";
import userServices from "../../services/users";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import DSpinner from "../../components/DSpinner";
import ListInput from "../../components/ListInput";
const initialValues = {
  amount: "",
};
const balanceType = [
  {
    id: 0,
    title: "اختر نوع العملية",
    value: "",
  },
  {
    id: 1,
    title: "شحن",
    value: 1,
  },
  {
    id: 2,
    title: "سحب",
    value: 0,
  },
];
const validationSchema = Yup.object().shape({
  amount: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(-1, "الكمية يجب ان تكون اكبر او تساوي 0")
    .required("هذا الحقل مطلوب"),
  balanceType: Yup.string().test("checkValue", "هذا الحقل مطلوب", (value) => {
    return value;
  }),
});
const Balance = ({ title }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [userSearch, setUserSearch] = useState("");

  const { data, isLoading, error } = useQuery(["getAllUsers"], async () => {
    const res = await userServices.getAllUsers();
    if (res.data.data.last_page > 1) {
      const pagesArray = [...Array(res.data.data.last_page).keys()];
      const all = await Promise.all(
        pagesArray.map((p) => {
          return userServices.getAllUsers(p + 1);
        })
      );
      return formattedUsers(all);
    } else {
      return res?.data?.data?.data;
    }
  });
  const formattedUsers = (data) => {
    return (
      data.flat(1).map((d) => ({
        key:  d.id.toString() + " - " + d.name.toString() ,
        value: d.id.toString(),
        title: d.name  ,
        ...d,
      })) || []
    );
  };
  const onSubmit = (values, { setSubmitting }) => {
    if (+values.balanceType === 1) {
      userServices
        .addBalance(values, userSearch)
        .then((res) => {
          toast.success("تم الشحن بنجاح");
          queryClient.refetchQueries("getUsers");
          setTimeout(() => {
            navigate("/users", { replace: true });
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
          toast.error("فشلت العملية حاول مرة اخرى");
          setTimeout(() => {
            setSubmitting(false);
          }, 1500);
        });
    } else {
      userServices
        .discountBalance(values, userSearch)
        .then((res) => {
          toast.success("تم السحب بنجاح");
          queryClient.refetchQueries("getUsers");
          setTimeout(() => {
            navigate("/users", { replace: true });
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
          toast.error("فشلت العملية حاول مرة اخرى");
          setTimeout(() => {
            setSubmitting(false);
          }, 1500);
        });
    }
  };

  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <PageHeading>{title}</PageHeading>

      <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <FormikContainer
            onSubmit={onSubmit}
            initialValues={{
              ...initialValues,
              balanceType: "",
              balance:
                +data.find((d) => d.id === +userSearch)?.balance.toFixed(6) +
                  "$" || 0,
            }}
            validationSchema={validationSchema}
          >
            {({ isSubmitting }) => {
              return (
                <Form>
                  <div className="md:grid md:grid-cols-2 gap-4">
                    <div className="mb-4">
                      <ListInput
                        title="معرف المستخدم:"
                        options={formattedUsers(data)}
                        setSelectValue={setUserSearch}
                      />
                    </div>
                    <FieldContainer
                      type="text"
                      name="balance"
                      id="balance"
                      label={`رصيد المستخدم الحالي`}
                      readOnly
                      disabled
                    />
                    <FieldContainer
                      type="select"
                      name="balanceType"
                      id="balanceType"
                      options={balanceType}
                      label="نوع العملية"
                    />
                    <FieldContainer
                      type="text"
                      name="amount"
                      id="amount"
                      label="الرصيد المراد شحنها"
                    />
                  </div>
                  <DButton
                    disabled={isSubmitting}
                    type="submit"
                    className="mx-auto min-w-[150px] flex items-center justify-center text-white"
                  >
                    {isSubmitting ? <Spinner /> : "معالجة"}
                  </DButton>
                </Form>
              );
            }}
          </FormikContainer>
        )}
      </DCard>
    </div>
  );
};

export default Balance;
